$(function () {
  if(!$('.js-billing-account-select').length) return;

  $('.js-billing-account-select').on('change', function(){
    var optionSelected = $("option:selected", this);
    var url = optionSelected.data('url');
    window.location = url;
  });
});
